import { AiFillAmazonCircle, AiFillRobot } from "react-icons/ai";
import {
  BsCalendar3,
  BsCalendar4Week,
  BsFillPatchCheckFill,
  BsImages,
} from "react-icons/bs";
import { CiViewList } from "react-icons/ci";
import { FaFileInvoiceDollar, FaStore, FaTruck } from "react-icons/fa";
import { FaCircleExclamation, FaDisplay, FaUserTie } from "react-icons/fa6";
import { FiCircle } from "react-icons/fi";
import { GoGoal, GoProject, GoShieldCheck } from "react-icons/go";
import { GrCatalog } from "react-icons/gr";
import { HiOutlineDocumentReport, HiOutlineShoppingBag } from "react-icons/hi";
import { HiMiniBeaker } from "react-icons/hi2";
import { IoShirtOutline, IoStatsChart } from "react-icons/io5";
import { PiPackageBold } from "react-icons/pi";
import {
  RiBarcodeFill,
  RiDashboard3Line,
  RiListSettingsFill,
  RiMoneyDollarCircleLine,
} from "react-icons/ri";
import { SiProducthunt, SiShopify } from "react-icons/si";
import { TbCube3dSphere, TbReportMoney } from "react-icons/tb";
import { TiBusinessCard } from "react-icons/ti";
import { INTERNAL, QC } from "utils/permissions";

const ROUTES = {
  development: [
    {
      path: "/development/projects",
      text: "Team Red",
      icon: <GoProject size={14} />,
      color: "text-sky-400",
    },
    {
      path: "/development/gtm-projects",
      text: "Go to Market",
      icon: <FaCircleExclamation size={14} />,
      color: "text-red-400",
    },
    {
      path: "/development/sales-dashboard",
      text: "For Sales",
      icon: <RiDashboard3Line size={14} />,
      color: "text-green-400",
    },
  ],

  ai: [
    {
      path: "/ai/ask",
      text: "Mr Bob",
      icon: <AiFillRobot size={14} />,
      color: "text-green-400",
    },
  ],

  products: [
    {
      path: "/products",
      text: "Products",
      icon: "ball",
      color: "text-pink-400",
    },
    {
      path: "/gears",
      text: "Marketing Gears",
      icon: <IoShirtOutline size={14} />,
      color: "text-purple-400",
    },
    {
      path: "/product-list",
      text: "Product List",
      icon: "view-list",
      color: "text-red-400",
    },
    {
      path: "/calculate",
      text: "Calculate",
      icon: "calculator",
      color: "text-blue-400",
    },
    { path: "/stock", text: "Stock", icon: "stock", color: "text-green-400" },
    {
      path: "/price",
      text: "Costs",
      icon: <RiMoneyDollarCircleLine size={14} />,
      color: "text-yellow-400",
    },
    {
      path: "/certificates",
      text: "Certificates",
      icon: <GoShieldCheck size={14} />,
      color: "text-teal-400",
    },
    {
      path: "/test-reports",
      text: "Test Reports",
      icon: <HiMiniBeaker size={14} />,
      color: "text-teal-400",
    },
    {
      path: "/manage",
      text: "Manage",
      icon: <RiListSettingsFill size={14} />,
      color: "text-blue-400",
    },
    {
      path: "/validate",
      text: "Validate",
      icon: <BsFillPatchCheckFill size={14} />,
      color: "text-green-400",
    },
  ],
  sales: [
    {
      path: "/sales/products",
      text: "Products",
      icon: "ball",
      color: "text-blue-400",
    },
    {
      path: "/sales/inventory",
      text: "Inventory",
      icon: "stock",
      color: "text-teal-400",
    },
    {
      path: "/sales/customers",
      text: "Customers",
      icon: <FaUserTie size={14} />,
      color: "text-yellow-400",
    },
    {
      path: "/sales/price-lists",
      text: "Price Lists",
      icon: <CiViewList size={14} />,
      color: "text-indigo-400",
    },
    {
      path: "/order-scheduler",
      text: "Order Scheduler",
      icon: <BsCalendar3 size={14} />,
      color: "text-pink-400",
    },
    {
      path: "/sales/orders",
      text: "Sales Orders",
      icon: <HiOutlineShoppingBag size={14} />,
      color: "text-red-400",
    },
    {
      path: "/amazon",
      text: "Amazon Vendor Center",
      icon: <AiFillAmazonCircle size={14} />,
      color: "text-orange-400",
    },
    {
      path: "/sales/orders-v2/shopify-eu",
      text: "Shopify EU Orders",
      icon: <SiShopify size={14} />,
      color: "text-green-400",
    },
    // {
    //   path: "/sales/orders-v2",
    //   text: "Sales Orders V2",
    //   icon: <HiOutlineShoppingBag size={14} />,
    //   color: "text-red-400",
    // },
    {
      path: "/shipment",
      text: "Shipments",
      icon: "ship",
      color: "text-pink-400",
    },
    {
      path: "/sales/reports",
      text: "Sales Reports",
      icon: <HiOutlineDocumentReport size={14} />,
      color: "text-pink-400",
    },
    {
      path: "/sales/forecast",
      text: "Forecast",
      icon: <IoStatsChart size={14} />,
      color: "text-green-400",
    },
  ],

  supplyChain: [
    {
      path: "/suppliers",
      text: "Suppliers",
      icon: <TiBusinessCard size={14} />,
      color: "text-pink-400",
    },
    {
      path: "/supplier-calendar",
      text: "Production Calendar",
      icon: <BsCalendar4Week size={14} />,
      color: "text-red-400",
    },
    {
      path: "/production",
      text: "Production",
      icon: <SiProducthunt size={14} />,
      color: "text-teal-400",
    },
    {
      path: "/sub-supplier",
      text: "Sub-Supplier",
      icon: <FaFileInvoiceDollar size={14} />,
      color: "text-yellow-400",
    },
  ],
  retailer: [
    {
      path: "/retailer-store/products",
      text: "Products",
      icon: "ball",
      color: "text-blue-400",
    },
    {
      path: "/retailer-store/agents",
      text: "Agents",
      icon: "user",
      color: "text-blue-400",
    },
    {
      path: "/retailer-store/retailers",
      text: "Retailers",
      icon: "user",
      color: "text-green-400",
    },
    {
      path: "/retailer-store/orders",
      text: "Orders",
      icon: <FaFileInvoiceDollar size={14} />,
      color: "text-purple-400",
    },
  ],

  inc: [
    {
      path: "/inc/products",
      text: "Products",
      icon: "ball",
      color: "text-blue-400",
    },
    {
      path: "/inc/orders",
      text: "Orders",
      icon: <FaStore size={14} />,
      color: "text-blue-400",
    },
    {
      path: "/inc/fsi",
      text: "FSI",
      icon: <FaTruck size={14} />,
      color: "text-indigo-400",
    },
  ],

  orders: [
    {
      path: "/odoo",
      text: "Odoo",
      icon: <FiCircle size={14} />,
      color: "text-purple-400",
    },
  ],
  accounting: [
    {
      path: "/accounting/cashflow",
      text: "Cashflow",
      icon: <TbReportMoney size={14} />,
      color: "text-green-400",
    },
  ],
  qc: [
    { path: "/qc", text: "QC Reports", icon: "paste", color: "text-pink-400" },
  ],
  esg: [
    {
      path: "/assessment",
      text: "Assessment",
      icon: "factory",
      color: "text-blue-400",
    },
  ],

  materials: [
    {
      path: "/materials/landing",
      text: "Landing",
      icon: <FaDisplay />,
      color: "text-sky-400",
    },
    {
      path: "/materials/beautyshots",
      text: "Beautyshots",
      icon: <BsImages />,
      color: "text-pink-400",
    },
    {
      path: "/materials/lifestyle-images",
      text: "Lifestyle Images",
      icon: "beverage",
      color: "text-green-400",
    },
    {
      path: "/materials/logos",
      text: "Logos",
      icon: "color-palette",
      color: "text-green-400",
    },
    {
      path: "/materials/videos",
      text: "Videos",
      icon: "video",
      color: "text-yellow-400",
    },
    {
      path: "/materials/catalogs",
      text: "Catalogs",
      icon: <GrCatalog />,
      color: "text-blue-400",
    },
    {
      path: "/materials/marketing",
      text: "Marketing",
      icon: <FaDisplay />,
      color: "text-indigo-400",
    },
  ],
  tools: [
    {
      path: "/tools/shopify-alc",
      text: "Shopify & ALC",
      icon: <SiShopify size={14} />,
      color: "text-green-400",
    },
    {
      path: "/tools/shortlinks",
      text: "Short Links",
      icon: "link",
      color: "text-yellow-400",
    },
    {
      path: "/barcode",
      text: "Barcode",
      icon: <RiBarcodeFill size={14} />,
      color: "text-indigo-400",
      target: "_blank",
    },
    {
      path: "/tools/3d",
      text: "3D",
      icon: <TbCube3dSphere size={14} />,
      color: "text-indigo-400",
    },
    {
      path: "/tools/patentai",
      text: "Patent AI",
      icon: <AiFillRobot size={14} />,
      color: "text-green-400",
    },
    {
      path: "/tools/package",
      text: "Package Tracking",
      icon: <PiPackageBold size={14} />,
      color: "text-orange-400",
    },
    {
      path: "/tools/invoice-verify",
      text: "Invoice Verify",
      icon: <FaFileInvoiceDollar size={14} />,
      color: "text-teal-400",
    },
    {
      path: "/tools/system-tasks",
      text: "System Tasks",
      icon: <RiListSettingsFill size={14} />,
      color: "text-sky-400",
    },
  ],
  objectives: [
    {
      path: "/objectives",
      text: "Objectives",
      icon: <GoGoal size={14} />,
      color: "text-red-400",
    },
  ],
  analytics: [
    {
      path: "/analytics/sales",
      text: "Sales",
      icon: "chart",
      color: "text-indigo-400",
    },
    {
      path: "/analytics/qc",
      text: "QC",
      icon: "chart",
      color: "text-teal-400",
    },
    {
      path: "/analytics/production",
      text: "Production",
      icon: "chart",
      color: "text-teal-400",
    },
    {
      path: "/analytics/grading",
      text: "Supplier Grading",
      icon: "chart",
      color: "text-green-400",
    },
    {
      path: "/analytics/odoo",
      text: "Odoo Margins",
      icon: "chart",
      color: "text-purple-400",
    },
  ],
  manage: [
    { path: "/manage/accounts", text: "Accounts", icon: "user" },
    {
      blank: true,
      path: process.env.REACT_APP_SERVER_ADMIN_URL,
      text: "Admin",
      icon: "shield",
      color: "text-green-400",
    },
    { path: "/it", text: "IT", icon: "code", color: "text-pink-400" },
  ],
};

export const getUserRoutes = (hasPermission) => {
  const routes = [];

  if (hasPermission(INTERNAL)) {
    routes.push({ text: "Projects", path: ROUTES.development });

    routes.push({ text: "Products", path: ROUTES.products });
    routes.push({ text: "Sales", path: ROUTES.sales });
    routes.push({ text: "Orders", path: ROUTES.orders });
    routes.push({ text: "INC", path: ROUTES.inc });
    routes.push({ text: "Supply Chain", path: ROUTES.supplyChain });
    routes.push({ text: "Accounting", path: ROUTES.accounting });
    routes.push({ text: "QC", path: ROUTES.qc });
    routes.push({ text: "ESG", path: ROUTES.esg });
    routes.push({ text: "Materials", path: ROUTES.materials });
    routes.push({ text: "Tools", path: ROUTES.tools });
    routes.push({ text: "Analytics", path: ROUTES.analytics });
    routes.push({ text: "Objectives", path: ROUTES.objectives });
    routes.push({ text: "Manage", path: ROUTES.manage });
    routes.push({ text: "Retailer Store", path: ROUTES.retailer });
    routes.push({ text: "AI", path: ROUTES.ai });
  } else if (hasPermission(QC)) {
    routes.push({ text: "QC", path: ROUTES.qc });
  }
  return routes;
};
